import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import {
  ChangeIndicatedCurrency,
  ChangeIndicatedPercent,
} from '../../../../../../../src/components/common/number';
import {
  NavigationList,
  NavigationListItem,
  NavigationListItemHeader,
  NavigationListItemContent,
  NavigationListItemFooter
} from '@dbk/ui-list';
import { AssetItemHeaderDescription } from '../../../../../../../src/components/common/asset/asset-item/asset-item-header';
import { MARKER_COLOURS, NO_DATA , PORTFOLIO_RELIDTYPE, KEY_CODE } from '../../../../../../../src/constants';
import { createContainer } from '@dbk-legacy/muster/react';

function AssetList({ changePage, columns, assets, rsa, setRsaPageName, portfolio, selectedPortfolioData, activeId, selectedPortfolio, selectedPorfolioItem, i18n: { messages } }) {

  let hideArrow = false;
  if (selectedPortfolioData.relId != null) {
    hideArrow = true;
  } else {
    hideArrow = false;
  }

  function handleRowPressed(asset, portfolio, selectedPortfolioData, messages, e) {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
    const targetAssetClass = asset.category.id;
    // WMCE -4443 , Asset drill down disabled for BP and Consolidation data
    if (selectedPortfolioData.relId != null || selectedPortfolioData.relIdType !== PORTFOLIO_RELIDTYPE.PORTFOLIOS) {
      alert(messages['app.portfolio.circularChart.selPort']);
    } else {
      portfolio.setAssetClassDesc(asset.category.name);
      if (rsa.rsaAuthorised === undefined || rsa.rsaAuthorised === false) {
        portfolio.setAssetPositionClassName(asset.category.id);
        rsa.onChangePage('/portfolios/genericAssets');
        portfolio.setAssetClassName(asset.category.id);
      } else {
        portfolio.setAssetClassName(asset.category.id);
        changePage('/portfolios/genericAssets');
      }
    }
  }
  }

  const filteredAssets = assets.filter((asset) => !!asset.category.id);

  const renderListItems = (items, selectedPorfolioItem) => items.map((item, index) => {
      const { category, allocation, marketValue, dayChange } = item;
      const isSelected = (selectedPorfolioItem && ((selectedPorfolioItem.category && selectedPorfolioItem.category.id === category.id) || (selectedPorfolioItem.id === category.id)));
      return (
        
    <NavigationListItem tabIndex={-1} testID="list_portfolio_dashboard_assetList_test" onClick={
          () =>  handleRowPressed(
            item,
            portfolio,
            selectedPortfolioData,
            messages
          )
        }
          onKeyDown={(e) => handleRowPressed(
            item,
            portfolio,
            selectedPortfolioData,
            messages, e
          )}
          selected={isSelected}
          color={MARKER_COLOURS[category.id].fill}
          label={messages['app.faq.viewDetails']} // for rightArrow to read as view datails - Accessibility
        >
          <NavigationListItemHeader tabIndex={0} aria-label={category.id==="others"?messages['app.assets.othersIncLoans']:category.name}>
            <AssetItemHeaderDescription
              row={{
                description: category.name || NO_DATA,
              }}
            />
          </NavigationListItemHeader>
          <div className="assetListStylesCH">
          <NavigationListItemFooter>
            {/* <View style={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}> */}
            <div className="row">
              <div tabIndex={0} className="column large-3 medium-3 small-3 margin-left-15" >
                <ChangeIndicatedPercent
                  value={allocation.value}
                  onlyNegativeStyling
                />
              </div>
              <div tabIndex={0} className="column large-5 medium-5 small-5 text-align-right">
                <ChangeIndicatedCurrency
                  value={marketValue.value}
                  onlyNegativeStyling
                />
              </div>
              <div tabIndex={0} className="column large-3 medium-3 small-3 text-align-right color-pale-blue">
                <ChangeIndicatedPercent
                  value={dayChange.percent}
                />
              </div>
            </div>
            {/* </View> */}
          </NavigationListItemFooter>
          </div>
          {/* <NavigationListItemContent color="#FF3838">
            <ChangeIndicatedPercent
              value={dayChange.percent}
              renderProps={{ size: 'large20' }}
            />
          </NavigationListItemContent> */}
        </NavigationListItem>
      )
    })

  return (
    <View>
      <NavigationList testID="list" className="asset-list">
        {renderListItems(filteredAssets, selectedPorfolioItem)}
      </NavigationList>
    </View>
  );
}

AssetList.defaultProps = {
  columns: [],
  assets: [],
};

AssetList.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    width: PropTypes.number,
  })),
  assets: PropTypes.arrayOf(PropTypes.shape({
    category: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
    allocation: PropTypes.shape({
      value: PropTypes.number,
    }),
    marketValue: PropTypes.shape({
      value: PropTypes.number,
    }),
    dayChange: PropTypes.shape({
      percent: PropTypes.number,
    }),
  })),
  changePage: PropTypes.func,
};

export default createContainer({
  $queries: {
    rsa: {
      rsaAuthorised: true,
      onChangePage: { $call: 'changePage' },
    },
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    setRsaPageName: { $set: 'ui.state.rsaPageName' },
    portfolio: {
      setAssetPositionClassName: { $set: 'AssetPositionClassName' },
      setAssetClassName: { $set: 'assetClassName' },
      setAssetClassDesc: { $set: 'selectedAssetDesc' },
      // setAssetObj: { $set: 'selectedAssetObj'},
      // headerAssetObj: { $set: 'assetSelectedObj'},
    },
    app: {
      user: {
        selectedPortfolioData: true,
      }
    },
  },
}, ({ app, ...queries }) => ({
  ...queries,
  selectedPortfolioData: app.user.selectedPortfolioData,
}))(AssetList);
